import Section from "components/general/Section";
import Seo from "components/general/Seo";
import { adminNavigationCollection } from "components/navigation/AdminNavigation";
import { Box, H1, Link, Text } from "components/ui";
import { useNavigation, usePathname, useSegments } from "expo-router";
import { Settings } from "lucide-react-native";
import React from "react";
import { useIsMobile } from "utils/hooks/useIsMobile";

export default function Page() {
	let currentPath = usePathname();
	const isMobile = useIsMobile();

	return (
		<Box height={"$full"}>
			<Seo title="Admin | Abconet" description="Access and manage all administrative settings and configurations." />
			<Section height="$full" justifyContent="center" alignItems="center">
				<Box width={"$full"} height={"$full"} maxWidth={638} mx={"auto"}>
					<Box justifyContent="center" mt={isMobile ? 32 : 0} mb={32} flexDirection="column">
						<Box mb={8} mt={8} alignItems="center" justifyContent="center" flexDirection="row" gap={8}>
							<Settings size={40} color={"black"} />
							<H1>Admin</H1>
						</Box>

						<Text paddingHorizontal={8} textAlign="center" textTransform="uppercase">
							System administration - Manage your sites, users, and lists
						</Text>
					</Box>
					<Box gap={16} justifyContent="center" flexDirection="row" flexWrap="wrap">
						{adminNavigationCollection.map((nav, index) => {
							if (nav.title === "Roles") return null;

							return (
								<Box key={index} width={isMobile ? "$1/3" : "$1/4"}>
									<Link
										key={nav.href}
										href={nav.href}
										component={(hovered) => {
											let bg = "$basicwhite";
											if (hovered) bg = "$lighttealxlight";

											return (
												<Box gap={16} overflow="hidden" borderRadius={16} borderWidth={1} height={100} bg={bg} justifyContent="center" borderColor="$primarylightblue" alignItems="center">
													{nav.icon}
													<Text fontSize={14}>{nav.title}</Text>
												</Box>
											);
										}}
									/>
								</Box>
							);
						})}
					</Box>
				</Box>
			</Section>
		</Box>
	);
}
